import { gql } from 'graphql-request'

export const SetSpeciGql = gql`
  mutation setSpeci($speci: SpeciDtoInput!, $stationRecordNumber: String!) {
    setSpeci(request: { speci: $speci, stationRecordNumber: $stationRecordNumber }) {
      errorMessage
      success
    }
  }
`
